/** 糖尿病 */

/** 对应的标题 */
const categoryMap = {
  'Calvert': '卡铂 AUC 剂量',
}
/** 对应的描述 */
const categoryDescMap = {

}
export default {
  categoryMap,
  categoryDescMap
}


// WEBPACK FOOTER //
// ./src/utils/category/Diab.js